#import "../../NotifyTimeFields.graphql"
mutation NotifyTimeCreate($input: NotifyTimeCreateInput!) {
  notifyTimeCreate(input: $input) {
    notifyTime {
      ...NotifyTimeFields
    }
  }
}
